import { Injectable, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Faq as FaqInterface } from '@redirector-service/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FAQService {
  private http = inject(HttpClient);


  private static API_HOST = environment.apiHost || '';

  getFAQs(): Observable<FaqInterface[]> {
    return this.http.get<FaqInterface[]>(`${FAQService.API_HOST}/api/faq`);
  }
}
